// Completude do cadastro — sempre visível no topo do Aluno 360, com o que falta.
import React, { useCallback, useEffect, useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { CheckCircle2, CircleAlert } from 'lucide-react';
import api from '@/lib/api';

const tone = (p) => (p >= 95 ? { bg: 'bg-emerald-50', br: 'border-emerald-200', tx: 'text-emerald-700', bar: 'bg-emerald-500' }
  : p >= 70 ? { bg: 'bg-amber-50', br: 'border-amber-200', tx: 'text-amber-700', bar: 'bg-amber-500' }
    : { bg: 'bg-rose-50', br: 'border-rose-200', tx: 'text-rose-700', bar: 'bg-rose-500' });

export default function CompletudeBadge({ studentId, refreshKey }) {
  const [c, setC] = useState(null);

  const load = useCallback(async () => {
    if (!studentId) return;
    try {
      const { data } = await api.get(`/smart-import/students/${studentId}/completeness`);
      setC(data);
    } catch (_) { setC(null); }
  }, [studentId]);

  useEffect(() => { load(); }, [load, refreshKey]);

  if (!c) return null;
  const t = tone(c.percent);
  const complete = c.percent >= 100;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="completude-badge"
          className={`flex items-center gap-2 pl-2 pr-3 py-1 rounded-full border ${t.bg} ${t.br} ${t.tx} hover:brightness-95 transition-all`}>
          {complete ? <CheckCircle2 className="h-4 w-4" /> : <CircleAlert className="h-4 w-4" />}
          <span className="text-[13px] font-semibold">Cadastro {c.percent}%</span>
          <span className="w-14 h-1.5 rounded-full bg-white/70 overflow-hidden hidden sm:block">
            <span className={`block h-full ${t.bar}`} style={{ width: `${c.percent}%` }} />
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72" data-testid="completude-popover">
        <p className="text-sm font-semibold text-slate-800">
          {c.filled} de {c.total} informações preenchidas
        </p>
        {complete || !c.missing_labels?.length ? (
          <p className="text-[13px] text-emerald-700 mt-2">Cadastro completo. Nada pendente.</p>
        ) : (
          <>
            <p className="text-[12px] text-slate-500 mt-2 mb-1.5">Falta preencher:</p>
            <ul className="space-y-1 max-h-56 overflow-y-auto">
              {c.missing_labels.map((m) => (
                <li key={m} className="text-[13px] text-slate-700 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-400" /> {m}
                </li>
              ))}
            </ul>
          </>
        )}
      </PopoverContent>
    </Popover>
  );
}
